import { render, staticRenderFns } from "./sponsor-details.vue?vue&type=template&id=0f687c22&scoped=true&"
import script from "./sponsor-details.vue?vue&type=script&lang=js&"
export * from "./sponsor-details.vue?vue&type=script&lang=js&"
import style0 from "./sponsor-details.vue?vue&type=style&index=0&id=0f687c22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f687c22",
  null
  
)

export default component.exports